export default {"src":"/_next/static/media/Warts and Skin Tags.6b2926d7.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};